import { render } from "./GrapesJS.vue?vue&type=template&id=22e8440c"
import script from "./GrapesJS.vue?vue&type=script&lang=js"
export * from "./GrapesJS.vue?vue&type=script&lang=js"

import "./GrapesJS.vue?vue&type=style&index=0&id=22e8440c&lang=css"
script.render = render

export default script